module.exports = __webpack_public_path__ + "img/cn.c1b7e224.svg";